import FontSize from "./font-size"
import {SkinColors} from "./colors/skin-colors";
import {DarkSkinColors} from "./colors/skins/dark-skin-colors";
import {LightSkinColors} from "./colors/skins/light-skin-colors";
import {
    LayoutThemeUserSetting,
    MainMenuBackground,
    NavigationBackground,
    SkinTheme,
    UIType
} from "../../../layout/ui/@const";
import PaletteProto from "./skin-palette/palette-proto";

const {build} = require('../../../../app/web/version')

const debug = false
// const debug = "Skin manager"

export default class Skin {

    public layoutTheme      : SkinTheme             = SkinTheme.LIGHT  // light | dark // css file skin
    public loadedFiles      : any[]                 = []
    public fontSize         : FontSize | null       = null
    public colors           : SkinColors

    public commonPalette    : PaletteProto | null   = null // New for Different Colors. Used for customize new Skins
    public grayPalette      : PaletteProto | null   = null // Only for Gray palette

    constructor() {

        // const mode = _.get(gd, 'user.settings.skin.theme', defaultTheme)
        const mode = gd.user.settings.skin.theme

        debug && console.log("user.settings.skin.theme = ", gd.user.settings.skin.theme)
        debug && console.log("mode = ", mode)

        switch (mode) {
            case LayoutThemeUserSetting.LIGHT:
                debug && console.log("switch light")
                this.layoutTheme = SkinTheme.LIGHT
                break

            case LayoutThemeUserSetting.DARK:
                debug && console.log("switch dark")
                this.layoutTheme = SkinTheme.DARK
                break

            case LayoutThemeUserSetting.AUTO:
            default:
                debug && console.log("switch auto/default")

                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    debug && console.log("Using system preference and set to dark")
                    this.layoutTheme = SkinTheme.DARK
                }
                break
        }

        debug && console.log("currenSkin = ", this.layoutTheme)

        this.init();

        switch (this.layoutTheme) {
            case SkinTheme.DARK :
                this.colors = new DarkSkinColors(this)
                break

            case SkinTheme.LIGHT:
            default             :
                this.colors    = new LightSkinColors(this)
        }
    }

    // required for shared view and others support
    // SkinManager should be created and available before init to use its methods (like loadDeferred)
    init() {

        // Experimental - add skin class to body
        // const layoutContainer = document.getElementById("ui-layout-container")
        const layoutContainer = document.body
        layoutContainer.className = '' // Reset classes. (Needed when changing skins)
        layoutContainer.classList.add('skin-'+this.layoutTheme)

        if (gd.ui.type === UIType.GOODDAY_MODERN) {
            layoutContainer.classList.add('skin-goodday-modern')

            if (gd.user.settings.skin.menu === MainMenuBackground.PALE) {
                switch (gd.user.settings.skin.navigation) {
                    case NavigationBackground.BLUE:
                        layoutContainer.classList.add('blue')
                        break
                    case NavigationBackground.VIOLET:
                        layoutContainer.classList.add('violet')
                        break
                    case NavigationBackground.GREEN:
                        layoutContainer.classList.add('green')
                        break
                    case NavigationBackground.TURQUOISE:
                        layoutContainer.classList.add('turquoise')
                        break
                    case NavigationBackground.DARK:
                        layoutContainer.classList.add('dark')
                        break
                    case NavigationBackground.GRAY:
                        layoutContainer.classList.add('gray')
                        break
                }
            } else if (gd.user.settings.skin.menu === MainMenuBackground.GRAY) {
                layoutContainer.classList.add('gray')
            }
        }

        if (gd.ui.type === UIType.TEAMS && this.layoutTheme === SkinTheme.DARK) {
            layoutContainer.classList.add('skin-teams-dark')
        }

        if (gd.ui.type === UIType.TEAMS && this.layoutTheme === SkinTheme.LIGHT) {
            layoutContainer.classList.add('skin-teams-light')
        }

        if (gd.ui.type === UIType.CLICK_UP && this.layoutTheme === SkinTheme.DARK) {
            layoutContainer.classList.add('skin-click-up-dark')
        }

        if (gd.ui.type === UIType.CLICK_UP && this.layoutTheme === SkinTheme.LIGHT) {
            layoutContainer.classList.add('skin-click-up-light')
        }

        // end set body class

        // // Init gray palette (contrast)
        // // gd may not be initialized yet - why how ?
        // // @ts-ignore
        // const lightPalette  = _.get(window.gd, 'user.settings.skin.lightPalette', null);
        // // @ts-ignore
        // const darkPalette  = _.get(window.gd, 'user.settings.skin.darkPalette', null);

        this.commonPalette = gd.ui.getCommonPalette(this.layoutTheme) // New Palette !!!!!
        this.grayPalette = gd.ui.getGrayPalette(this.layoutTheme)

        // Init font size
        // @ts-ignore
        const fontSize      = _.get(window.gd, 'user.settings.skin.fontSize', null);
        this.fontSize       = fontSize ? new FontSize(fontSize) : null;

        // init theme
    }

    get isLight() {
        return this.layoutTheme === SkinTheme.LIGHT
    }

    get isDark() {
        return this.layoutTheme === SkinTheme.DARK
    }

    getLogoPath() {
        return "/app/web/skin/"+this.layoutTheme+"/img/logo.png?"+build;
    }

    getIconPath(iconName:string) {
        return "/app/web/skin/"+this.layoutTheme+"/img/icons/"+iconName+"?"+build;
    }

    loadDeferred(appName:string,cssFileName:string) {
        return this.load2018(appName, cssFileName);
    }

    async loadCssFile(cssFileName:string):Promise<void> {

        // it's always the same these days
        const appName:string = cssFileName;

        // check if already loaded
        let isFound = false;

        _.forEach(this.loadedFiles, obj=>{
            if (obj.appName === appName && obj.cssFileName === cssFileName) {
                isFound = true;
            }
        });

        if (isFound) return;

        const fileName = gdConfig.assetsPath + "/skin/"+this.layoutTheme+"/"+appName+"/"+cssFileName+".css";
        return gd.loader.css.loader2018(fileName).promise();
    }

    load2018(appName:string,cssFileName:string) {

        let isFound = false;

        _.forEach(this.loadedFiles, obj=>{
            if (obj.appName === appName && obj.cssFileName === cssFileName) {
                isFound = true;
            }
        });

        if (isFound) return true;

        this.loadedFiles.push({
            appName: appName,
            cssFileName: cssFileName
        });

        const fileName = gdConfig.assetsPath + "/skin/"+this.layoutTheme+"/"+appName+"/"+cssFileName+".css";
        return gd.loader.css.loader2018(fileName);
    }
}
